const styles = {
  root: {
    backgroundColor: 'background.default',
    marginY: 1,
    paddingY: 3,
  },

  title: {
    marginBottom: 3,
    '&.v1': {
      fontWeight: '700 !important',
      fontSize: '20px !important',
      lineHeight: '22px !important',
      color: 'common.blueDark',
    },
  },

  customCardBtn: {
    '& .MuiButton-root': {
      maxWidth: { lg: 230 },
      marginTop: 3,
    },
  },

  contactContainer: {
    marginBottom: 3,
    backgroundColor: 'theme.default',
    border: '1px solid rgba(0, 0, 0, 0.12)',
    borderRadius: '4px',
    paddingY: 3,
    paddingX: 2,
    '& .MuiTypography-h3': {
      marginBottom: 1,
    },
    '& .MuiBox-root > .MuiGrid-container': {
      '& .MuiGrid2-root': {
        maxWidth: { lg: '50%!important' },
      },
    },

    '&.MuiBox-root': {
      height: '100%',
    },
  },

  gridItem: {
    '& > div': {
      height: '100%',
    },
  },

  faqsContainer: {
    py: 4,
  },
  faqCategory: {
    pb: 2,
  },

  showMore: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },

  showMoreLink: {
    display: 'block',
  },
  dropDownButtonContainerUp: {
    position: 'absolute',
    bottom: 0,
    pt: 0,
  },
  dropDownButtonContainerDown: {
    position: 'relative',
  },

}

export default styles
